<script setup lang="ts">
/**
 * @author Alexander Kenchoshvili
 */

/** IMPORTS */
import { onMounted } from "vue";
import type { SecondaryDataInterface } from "@/types/ContentType";
import { useMainStore } from "@/store/main/index";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

const mainStore = useMainStore();

const props = defineProps<{
  contentData?: SecondaryDataInterface;
}>();

const data = props?.contentData?.data?.list[0];
</script>

<template>
  <div class="about-projects d-flex dir-col j-center al-center pos-rel">
    <div class="about-projects__inner w-full pos-rel">
      <div
        v-if="contentData?.conf?.header?.title"
        class="about-projects__header text-center hl-1-plus uppercase"
      >
        <h1>
          {{ contentData?.conf?.header?.title }}
        </h1>
      </div>
      <div class="about-projects__content d-flex dir-row j-center">
        <div class="about-projects__image-wrapper pos-rel w-full">
          <Picture
            :devices="data?.image?.[0]?.devices"
            imgClass="img-absolute"
            :alt="data?.title"
          />
        </div>

        <div class="about-projects__box d-flex dir-col j-btw w-full">
          <div class="about-projects__text p-12" v-html="data?.teaser">
          </div>
          <div class="about-projects__icon-boxes d-flex j-btw">
            <div class="about-projects__box-wrapper">
              <div class="about-projects__icon-box" v-html="data?.icon?.icon"></div>
              <span class="about-projects__icon-box-caption">{{
                data?.icon?.title
              }}</span>
            </div>
            <div class="about-projects__box-wrapper">
              <div class="about-projects__icon-box" v-html="data?.icon_2?.icon"></div>
              <span class="about-projects__icon-box-caption">{{
                data?.icon_2?.title
              }}</span>
            </div>
            <div class="about-projects__box-wrapper">
              <div class="about-projects__icon-box" v-html="data?.icon_3?.icon"></div>
              <span class="about-projects__icon-box-caption">{{
                data?.icon_3?.title
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./styles/AboutProjects.scss"></style>
